import { z } from 'zod';
import { uuidSchema } from './common.js';
// §33.1 scope decision matrix order.
export const integrationProviderSchema = z.enum(['twilio', 'quickbooks', 'google_calendar', 'google_reviews', 'webhooks', 'square']);
export const integrationStatusSchema = z.enum(['disconnected', 'pending_setup', 'connected', 'action_required', 'error']);
export const integrationSummarySchema = z.object({
    provider: integrationProviderSchema,
    label: z.string(),
    status: integrationStatusSchema,
    connectedAt: z.string().nullable(),
    lastHealthyAt: z.string().nullable(),
    errorDetail: z.string().nullable(),
});
export const integrationListResponseSchema = z.object({ items: z.array(integrationSummarySchema) });
export const messageDeliveryStatusSchema = z.enum(['queued', 'sent', 'delivered', 'failed', 'undelivered']);
export const trackingCallEventSchema = z.object({
    id: uuidSchema,
    workspaceId: uuidSchema,
    trackingNumberId: uuidSchema,
    callerE164: z.string(),
    callerName: z.string().nullable(),
    direction: z.enum(['inbound', 'outbound']),
    outcome: z.enum(['answered', 'missed', 'voicemail']),
    durationSeconds: z.number().int().min(0),
    relatedLeadId: uuidSchema.nullable(),
    createdAt: z.string(),
});
// §33.4 Phase 7 - outbound webhook event catalog.
export const WEBHOOK_EVENT_TYPES = ['lead.created', 'quote.sent', 'quote.accepted', 'job.scheduled', 'job.completed', 'payment.received'];
export const webhookEventTypeSchema = z.enum(WEBHOOK_EVENT_TYPES);
export const webhookEndpointSchema = z.object({
    id: uuidSchema,
    url: z.string(),
    subscribedEvents: z.array(webhookEventTypeSchema),
    status: z.enum(['active', 'disabled']),
    consecutiveFailures: z.number().int(),
    createdAt: z.string(),
});
export const createWebhookEndpointSchema = z.object({
    url: z.string().url(),
    events: z.array(webhookEventTypeSchema).min(1),
});
export const createWebhookEndpointResponseSchema = z.object({
    endpoint: webhookEndpointSchema,
    secret: z.string(),
});
//# sourceMappingURL=integrations.js.map